// import React, { useEffect, useState } from "react";
// import {
//   GoogleMap,
//   LoadScript,
//   DirectionsService,
//   DirectionsRenderer,
//   Marker,
//   InfoWindow,
// } from "@react-google-maps/api";

// const mapContainerStyle = {
//   width: "100%",
//   height: "500px",
// };

// const GoogleDistance = ({ distance_map_data }) => {
//   const [directions, setDirections] = useState(null);
//   const [mapCenter, setMapCenter] = useState({ lat: 22.2799, lng: 114.1733 });
//   const [originMarker, setOriginMarker] = useState(null);
//   const [destinationMarker, setDestinationMarker] = useState(null);
//   const [activeMarker, setActiveMarker] = useState(null);
//   const [selectedPlace, setSelectedPlace] = useState({});
//   const [showingInfoWindow, setShowingInfoWindow] = useState(false);
//   const [shouldRenderMap, setShouldRenderMap] = useState(false);

//   useEffect(() => {
//     setShouldRenderMap(false);
//     const timer = setTimeout(() => {
//       setShouldRenderMap(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, [distance_map_data]);

//   const [request, setRequest] = useState(null);

//   useEffect(() => {
//     if (shouldRenderMap && distance_map_data) {
//       const origin = distance_map_data.origin_addresses[0];
//       const destination = distance_map_data.destination_addresses[0];

//       setRequest({
//         origin,
//         destination,
//         travelMode: window.google.maps.TravelMode.DRIVING,
//       });
//     }
//   }, [shouldRenderMap, distance_map_data]);

//   const handleDirectionsCallback = (result, status) => {
//     if (status === "OK") {
//       setDirections(result);

//       const leg = result.routes[0].legs[0];
//       setOriginMarker({
//         position: leg.start_location,
//         address: leg.start_address,
//       });
//       setDestinationMarker({
//         position: leg.end_location,
//         address: leg.end_address,
//       });

//       const bounds = new window.google.maps.LatLngBounds();
//       bounds.extend(leg.start_location);
//       bounds.extend(leg.end_location);
//       setMapCenter(bounds.getCenter());
//       setRequest(null); // ✅ Clear the request after failure
//     } else {
//       console.error(`Directions request failed due to ${status}`);
//       setDirections(null);
//       setOriginMarker(null);
//       setDestinationMarker(null);
//       setMapCenter({ lat: 22.2799, lng: 114.1733 });
//       setRequest(null); // ✅ Clear the request after failure
//     }
//   };

//   const onMarkerClick = (markerData) => {
//     setSelectedPlace(markerData);
//     setActiveMarker(markerData);
//     setShowingInfoWindow(true);
//   };

//   return (
//      <div className="gogledistance_map">
//       <div id="gmaps-markers" className="gmaps" style={{ position: "relative", height: "500px" }}>
//     <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//       {shouldRenderMap ? (
//         <GoogleMap
//           mapContainerStyle={mapContainerStyle}
//           center={mapCenter}
//           zoom={15}
//           onClick={() => {
//             setShowingInfoWindow(false);
//             setActiveMarker(null);
//           }}
//         >
//           {request && (
//             <DirectionsService options={request} callback={handleDirectionsCallback} />
//           )}
//           {directions && (
//             <DirectionsRenderer directions={directions} />
//           )}
//           {originMarker && (
//             <Marker
//               position={originMarker.position}
//               label="A"
//               onClick={() => onMarkerClick(originMarker)}
//             />
//           )}
//           {destinationMarker && (
//             <Marker
//               position={destinationMarker.position}
//               label="B"
//               onClick={() => onMarkerClick(destinationMarker)}
//             />
//           )}
//           {showingInfoWindow && activeMarker && (
//             <InfoWindow position={activeMarker.position} onCloseClick={() => setShowingInfoWindow(false)}>
//               <div>
//                 <h6>{activeMarker.address}</h6>
//               </div>
//             </InfoWindow>
//           )}
//         </GoogleMap>
//       ) : (
//         <div style={{ textAlign: "center" }}>Loading Map...</div>
//       )}
//     </LoadScript>
//     </div>
//     </div>

//   );
// };

// export default GoogleDistance;

import React, { useEffect, useRef } from 'react';

const GoogleDistance = ({ distance_map_data }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!window.google || !distance_map_data) return;

    const originAddress = distance_map_data.origin_addresses[0];
    const destinationAddress = distance_map_data.destination_addresses[0];

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: originAddress }, (originResults, originStatus) => {
      if (originStatus === 'OK') {
        const origin = originResults[0].geometry.location;

        geocoder.geocode({ address: destinationAddress }, (destinationResults, destStatus) => {
          if (destStatus === 'OK') {
            const destination = destinationResults[0].geometry.location;

            const map = new window.google.maps.Map(mapRef.current, {
              zoom: 14,
              center: origin,
            });

            new window.google.maps.Marker({
              position: origin,
              map,
              label: "A",
              title: "Origin",
            });

            new window.google.maps.Marker({
              position: destination,
              map,
              label: "B",
              title: "Destination",
            });

            const directionsService = new window.google.maps.DirectionsService();
            const directionsRenderer = new window.google.maps.DirectionsRenderer();
            directionsRenderer.setMap(map);

            directionsService.route(
              {
                origin,
                destination,
                travelMode: window.google.maps.TravelMode.DRIVING,
              },
              (response, status) => {
                if (status === "OK") {
                  directionsRenderer.setDirections(response);
                  const route = response.routes[0].legs[0];
                  // alert(`Distance: ${route.distance.text}, Duration: ${route.duration.text}`);
                } else {
                  alert("Directions request failed: " + status);
                }
              }
            );
          } else {
            alert("Failed to geocode destination: " + destStatus);
          }
        });
      } else {
        alert("Failed to geocode origin: " + originStatus);
      }
    });
  }, [distance_map_data]);

  return (
    <div className='gogledistance_map'>
      <div className='gmaps' ref={mapRef} style={{ width: "100%", height: "400px" }}></div>
    </div>
  );
};

export default GoogleDistance;

